export const en = {
    archive: 'Archived',
    creatives: 'My creatives',
    upload: 'Upload'
};
